/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ProgrammingAssignmentCircledIcon = /*#__PURE__*/ createSvgIcon(
  'ProgrammingAssignmentCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M5.667 10.182l2.422 2.422c.114.115.171.26.171.438a.593.593 0 01-.171.437.593.593 0 01-.438.172.593.593 0 01-.437-.172l-2.875-2.875a.548.548 0 01-.133-.203.692.692 0 01-.04-.234c0-.084.014-.162.04-.235a.548.548 0 01.133-.203l2.875-2.875a.608.608 0 01.445-.187c.172 0 .32.062.445.187a.608.608 0 01.188.445c0 .172-.063.32-.188.446l-2.437 2.437zm8.969-.031l-2.422-2.422a.593.593 0 01-.172-.437c0-.177.057-.323.172-.438a.593.593 0 01.437-.172c.177 0 .323.058.438.172l2.875 2.875c.062.063.106.13.132.203a.69.69 0 01.04.235.69.69 0 01-.04.234.548.548 0 01-.132.203l-2.875 2.875a.573.573 0 01-.438.18.63.63 0 01-.437-.196.608.608 0 01-.188-.445c0-.172.063-.32.188-.445l2.421-2.422z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default ProgrammingAssignmentCircledIcon;
